import commonStore from "./CommonStore";
import {
  getMerchants,
  getMerchantDetail,
  getMerchantsOrder,
  updateMerchant,
} from "../services/MerchantService";
import { getJDCategoriesLocal } from "../services/JDCategoryService";

import { observable, action, decorate, computed } from "mobx";
import { validateEditedData } from "../helper/functions/functions";
import { reactLocalStorage } from "reactjs-localstorage";

const Joi = require("joi-browser");
Joi.objectId = require("joi-objectid")(Joi);

class MerchantStore {
  //OBSERVABLE
  dataArray = [];
  dataOrderArray = [];
  jdCategoryArray = [];
  getDataArrayLoading = false;
  editedData = {};
  adminWillBeChangeStatus = {};
  category = {};
  isChecked = false;
  searchQuery = null;
  pageSize = 20;
  currentPage = 0;
  totalCount = 0;
  statusAdminModal = false;
  categoryList = [];
  loggedInUser = null;
  SIUPImage = null;
  reload = false;

  constructor() {
    const currentUserString = reactLocalStorage.get("idealCurrentUser");
    if (currentUserString) {
      this.loggedInUser = JSON.parse(currentUserString);
    }
  }

  statusList = [
    { value: "true", label: "Active" },
    { value: "false", label: "Inactive" }
  ];

  sorting = [{ columnName: "createdDate", direction: "desc" }];

  //NOT OBSERVABLE
  pageSizes = [5, 10, 15, 0];
  stylesReactSelect = {
    control: base => ({
      ...base,
      borderColor: "#e4e7ea",
      color: "#5c6873",
      maxHeight: "35px",
      minHeight: "35px",
      "&:hover": {
        borderColor: "#e4e7ea"
      }
    })
  };

  toggleStatusAdminModal = () => {
    this.statusAdminModal = !this.statusAdminModal;
  };

  // ACTION
  getJDCategoryArrayFromServer = async (inputValue) => {
    this.categoryLoading = true;
    // const { categoryName, parentId, level, status } = this.filterData;
    let { data, error } = await getJDCategoriesLocal({
      searchQuery: inputValue,
      status: true,
      level: "3"
    });
    this.categoryLoading = false;
    if (error) {
      commonStore.showErrorMessage(error);
      return;
    }


    if (data) {
      this.jdCategoryArray = data.categories;
      this.totalCount = data.totalData;
    }

    return data;
  };

  // getDataArrayFromServer = async () => {
  //   this.getDataArrayLoading = true;
  //   const [sortingObject] = this.sorting;
  //   const { direction, columnName } = sortingObject;
  //   const sort = { [columnName]: direction };
  //   let { data, error } = await getMerchants({
  //     searchQuery: this.searchQuery,
  //     limit: this.pageSize,
  //     page: this.currentPage + 1,
  //     sortBy: JSON.stringify(sort)
  //   });
  //   this.getDataArrayLoading = false;
  //   if (error) {
  //     commonStore.showErrorMessage(error);
  //     return;
  //   }
  //   if (data) {
  //     this.dataArray = data.merchants;
  //     this.totalCount = data.totalData;
  //   }
  // };

  getDataOrdersFromServer = async () => {
    this.getDataArrayLoading = true;
    const [sortingObject] = this.sorting;
    const { direction, columnName } = sortingObject;
    const sort = { [columnName]: direction };
    let { data, error } = await getMerchantsOrder({
      limit: this.pageSize,
      page: this.currentPage + 1,
      sortBy: JSON.stringify(sort)
    });
    this.getDataArrayLoading = false;
    if (error) {
      commonStore.showErrorMessage(error);
      return;
    }
    if (data) {
      this.dataOrderArray = data.idealSettlement;
      this.totalCount = data.totalData;
    }
  };

  getSearchQueryAdminDataArrayFromServer = async query => {
    let { data, error } = await getMerchants({
      limit: this.pageSize,
      page: 0,
      searchQuery: query
    });

    if (error) {
      commonStore.showErrorMessage(error);
      return null;
    }

    if (data) {
      return data.admins;
    }
    return null;
  };

  // getMerchantsDetail = async merchantId => {
  //   this.getArrayDataLoading = true;

  //   let { error, data } = await getMerchantDetail(merchantId);
  //   this.getArrayDataLoading = false;
  //   if (error) {
  //     commonStore.showErrorMessage(error);
  //     return;
  //   }

  //   if (data) {
  //     this.editedData = data;
  //     return data;
  //   }
  // };

  getCategory = async merchantId => {
    this.getArrayDataLoading = true;

    let { error, data } = await getMerchantDetail(merchantId);
    this.getArrayDataLoading = false;
    if (error) {
      commonStore.showErrorMessage(error);
      return;
    }

    if (data) {
      this.editedData = data;
      return data.jdCategory
    }
  };

  // createMerchant = async history => {
  //   this.getDataArrayLoading = true;

  //   if(this.editedData.merchantId.length < 3) {
  //     commonStore.showErrorMessage("Merchant Id must be more than 3 digits");
  //     return;
  //   }

  //   let { data, error } = await createMerchant(this.editedData,this.categoryList);
  //   this.getDataArrayLoading = false;
  //   if (error) {
  //     commonStore.showErrorMessage(error);
  //     return;
  //   }

  //   if(typeof data === 'string') {
  //     commonStore.showErrorMessage(data);
  //     return;
  //   }

  //   if (data) {
  //     commonStore.showSuccessMessage("Merchant created successfully");
  //     history.push(`/merchants/listmerchant`);
  //   }
  // };

  // toogleMerchantStatus = async (userId, history) => {
  //   this.getDataArrayLoading = true;

  //   let { data, error } = await toogleMerchantStatus(userId);
  //   this.getDataArrayLoading = false;

  //   if (error) {
  //     commonStore.showErrorMessage(error.message);
  //     return;
  //   }


  //   if (data) {
  //     commonStore.showSuccessMessage(
  //       "Merchant has been change status successfully"
  //     );
  //     this.statusAdminModal = false;
  //     this.reload = true;
  //     //history.go(0);
  //   }
  // };

  updateMerchant = async history => {
    let {
      _id,
      merchantName,
      phoneNumber,
      password,
      confirmPassword,
      description,
      SIUP,
      picName,
      picPhoneNumber,
      isActive
    } = this.editedData;
    let merchId = _id;
    this.getDataArrayLoading = true;

    let { data, error } = await updateMerchant({
      merchId,
      merchantName,
      phoneNumber,
      password,
      confirmPassword,
      description,
      SIUP,
      picName,
      picPhoneNumber,
      isActive
    }, this.categoryList);
    this.getArrayDataLoading = false;

    if (error) {
      commonStore.showErrorMessage(error.message);
      return;
    }

    if (data) {
      commonStore.showSuccessMessage("Update Merchant has been successfully");
      this.editedData = data;
      history.push("/merchants/listmerchant");
    }
  };

  prepareCreateMode = () => {
    this.editedData = {
      merchantName: "",
      merchantId: "",
      phoneNumber: "",
      picName: "",
      password: "",
      SIUP: "",
      categoryList: [],
      picPhoneNumber: "",
      description: "",
      confirmPassword: "",
      isPasswordVisible: false,
      isPasswordConfirmVisible: false,
      isActive: "",
      passwordInputAttr: "password",
      confirmPasswordInputAttr: "password"
    };
  };

  setEditedData = editedData => {
    this.editedData = {
      ...this.editedData,
      ...editedData
    };
  };

  setCategoryList = list => {
    this.categoryList = list;
  };

  setStatusAdminModal = status => {
    this.statusAdminModal = status;
  };

  setSearchQuery = searchValue => {
    this.currentPage = 0;
    this.searchQuery = searchValue;
  };

  setCurrentPage = currentPage => {
    this.currentPage = currentPage;
  };

  setAdminWillBeChangeStatus = admin => {
    this.adminWillBeChangeStatus = admin;
  };
  setSorting = sorting => {
    this.sorting = sorting;
  };

  // COMPUTED
  get joiFormErrors() {
    if (this.editedData) {
      if (this.editedData.merchantId === "") {
        return validateEditedData({
          editedData: this.editedData,
          joiSchema: {
            merchantName: Joi.string()
              .trim()
              .required(),
            merchantId: Joi.string()
              .min(3)
              .trim()
              .required(),
            picName: Joi.string()
              .trim()
              .required(),
            phoneNumber: Joi.number().max(14),
            picPhoneNumber: Joi.number(),
            password: Joi.string().required(),
            confirmPassword: Joi.string()
              .required()
              .valid(Joi.ref("password"))
              .options({
                language: {
                  any: {
                    allowOnly: "Passwords do not match"
                  }
                }
              }),
            // isActive: Joi.boolean()
            //   .valid(Object.values(Constants.ADMIN_STATUS))
            //   .required()
          }
        });
      }
      if (this.editedData.merchantId !== "") {
        return validateEditedData({
          editedData: this.editedData,
          joiSchema: {
            merchantName: Joi.string()
              .trim()
              .required(),
            merchantId: Joi.string()
              .min(3)
              .trim()
              .required(),
            phoneNumber: Joi.number().max(14),
            picPhoneNumber: Joi.number(),
          }
        });
      }
    }
    //general state so submit button is always disabled on start of session
    return { error: true };
  }

  get changeAdminStatusModalTitle() {
    if (!this.adminWillBeChangeStatus) {
      return "";
    }

    return `${this.adminWillBeChangeStatus.isActive ? "Non Aktifkan" : "Aktifkan"
      } Admin`;
  }

  get changeAdminStatusModalContent() {
    if (!this.adminWillBeChangeStatus) {
      return "";
    }

    return `${this.adminWillBeChangeStatus.isActive ? "Non Aktifkan" : "Aktifkan"
      } status Admin ${this.adminWillBeChangeStatus.merchantName}`;
  }

  get changeAdminStatusModalConfirmButtonText() {
    if (!this.adminWillBeChangeStatus) {
      return "";
    }

    return `${this.adminWillBeChangeStatus.isActive ? "Non Aktifkan" : "Aktifkan"
      }`;
  }

  //Role ReactSelect
  get roleArrayForReactSelect() {
    if (this.roleList && this.roleList.length > 0) {
      return this.roleList.map(roleObject => {
        return {
          value: roleObject.value,
          label: roleObject.label
        };
      });
    }
    return [];
  }

  get roleDictionary() {
    const dictionary = {};
    if (this.roleList && this.roleList.length > 0) {
      this.roleList.forEach(roleObject => {
        dictionary[roleObject.value] = roleObject;
      });
    }
    return dictionary;
  }

  //Status ReactSelect
  get statusArrayForReactSelect() {
    if (this.statusList && this.statusList.length > 0) {
      return this.statusList.map(listObject => {
        return {
          value: listObject.value,
          label: listObject.label
        };
      });
    }
    return [];
  }

  get statusDictionary() {
    const dictionary = {};
    if (this.statusList && this.statusList.length > 0) {
      this.statusList.forEach(listObject => {
        dictionary[listObject.value] = listObject;
      });
    }
    return dictionary;
  }
}

decorate(MerchantStore, {
  getDataArrayLoading: observable,
  dataArray: observable,
  dataOrderArray: observable,
  editedData: observable,
  adminWillBeChangeStatus: observable,
  isChecked: observable,
  statusAdminModal: observable,
  roleList: observable,
  statusList: observable,
  searchQuery: observable,
  totalCount: observable,
  currentPage: observable,
  pageSize: observable,
  sorting: observable,
  loggedInUser: observable,
  jdCategoryArray: observable,
  category: observable,
  categoryList: observable,
  SIUPImage: observable,
  reload: observable,

  getDataArrayFromServer: action,
  setEditedData: action,
  createAdmin: action,
  toggleAdminStatus: action,
  setStatusAdminModal: action,
  setAdminWillBeChangeStatus: action,
  prepareCreateMode: action,
  setCurrentPage: action,
  setSearchQuery: action,

  joiFormErrors: computed,
  changeAdminStatusModalTitle: computed,
  changeAdminStatusModalContent: computed,
  changeAdminStatusModalConfirmButtonText: computed,
  roleArrayForReactSelect: computed,
  roleDictionary: computed,
  statusArrayForReactSelect: computed,
  statusDictionary: computed
});

export default new MerchantStore();
